module.exports = __webpack_public_path__ + "media/customizations/paintedtree/back-7261925432c5be7f5cc9b1fd8aa73d5f.jpg";